export default class SorterCriteria {
    constructor(field = '', order = 'asc', title = '', type = '') {
        this.field = field;
        this.order = order;
        this.title = title;
        this.type = type;
    }
}
